import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import { PricingTier } from '../types';

interface PricingCardProps {
  tier: PricingTier;
}

const PricingCard = ({ tier }: PricingCardProps) => {
  return (
    <div
      className={`relative bg-card rounded-xl border-2 transition-all duration-fast hover:shadow-lg ${
        tier.recommended
          ? 'border-primary shadow-md scale-105'
          : 'border-border hover:border-primary/50'
      }`}
    >
      {tier.popular && (
        <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-accent text-accent-foreground px-4 py-1 rounded-full text-sm font-semibold">
          Most Popular
        </div>
      )}

      <div className="p-8">
        <div className="mb-6">
          <h3 className="text-2xl font-bold text-text-primary mb-2">{tier.name}</h3>
          <p className="text-sm text-text-secondary mb-4">{tier.tagline}</p>
          <div className="flex items-baseline gap-2">
            <span className="text-4xl font-bold text-text-primary">
              ₹{tier.price.toLocaleString('en-IN')}
            </span>
            <span className="text-text-secondary">/{tier.billingPeriod}</span>
          </div>
          <p className="text-sm text-text-secondary mt-2">{tier.description}</p>
        </div>

        <Link to="/contact" className="block mb-6">
          <Button variant={tier.ctaVariant} size="lg" fullWidth>
            {tier.ctaText}
          </Button>
        </Link>

        <div className="space-y-4">
          <div>
            <h4 className="text-sm font-semibold text-text-primary mb-3 flex items-center gap-2">
              <Icon name="Check" size={16} className="text-success" />
              What's Included
            </h4>
            <ul className="space-y-2">
              {tier.features.map((feature, index) => (
                <li key={index} className="flex items-start gap-2 text-sm text-text-secondary">
                  <Icon
                    name="Check"
                    size={16}
                    className="text-success mt-0.5 flex-shrink-0"
                  />
                  <span>{feature}</span>
                </li>
              ))}
            </ul>
          </div>

          {tier.limitations.length > 0 && (
            <div className="pt-4 border-t border-border">
              <h4 className="text-sm font-semibold text-text-primary mb-3 flex items-center gap-2">
                <Icon name="Info" size={16} className="text-muted-foreground" />
                Limitations
              </h4>
              <ul className="space-y-2">
                {tier.limitations.map((limitation, index) => (
                  <li key={index} className="flex items-start gap-2 text-sm text-text-secondary">
                    <Icon
                      name="Minus"
                      size={16}
                      className="text-muted-foreground mt-0.5 flex-shrink-0"
                    />
                    <span>{limitation}</span>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PricingCard;